import { render, staticRenderFns } from "./HostMonitor.vue?vue&type=template&id=b83dfc56&scoped=true&"
import script from "./HostMonitor.vue?vue&type=script&lang=ts&"
export * from "./HostMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./HostMonitor.vue?vue&type=style&index=0&id=b83dfc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83dfc56",
  null
  
)

export default component.exports